import React, {useEffect} from "react";
import ShowOrEditGroupBasedFees from "./participation-fees/group-based.jsx";
import ShowOrEditSolidarityBasedFees from "./participation-fees/solidarity-based.jsx";
import {__, _nonce, _solea_get_local_groups} from '../../../../assets/javascripts/library.js';
import {useToaster} from "../../global-components/toaster.jsx";

function participationFees({event, toast_message = ''}){
    const { showToast } = useToaster();

    useEffect(() => {
        if (toast_message) {
            showToast(toast_message, 'success');
        }
    }, [toast_message]);

    let PaymentFees;


    switch (event.registration_mode) {
        case 'solidarity':
            PaymentFees = ShowOrEditSolidarityBasedFees;
            break;

        case 'groupbased':
            PaymentFees = ShowOrEditGroupBasedFees;
            break;
    }



    return (
      <div class="solea-page">
          <h3>{__('Participation fees', 'solea')}</h3>

          <PaymentFees
              event={event}
          />
      </div>
    );

}

export default participationFees;